export default __webpack_public_path__ + "static/media/TaperTurningImg.03e1f630.jpg";